import { Binding } from '@root/api/ump-plat-sdk-gateway'
import { getMtsBinding } from './getMtsBinding'

export const checkIsMtsClient = (
  bindings: Binding[],
  isAuth: boolean,
  operatorMTS: boolean,
  paymentBanMTS: boolean
) => {
  const mtsBinding = getMtsBinding(bindings)

  return Boolean(isAuth && operatorMTS && mtsBinding && !paymentBanMTS)
}
